<template>
  <div class="container">
    <div class="row" v-if="!msg">
      <div class="col">
        <i
          class="bi bi-arrow-clockwise text-primary"
          @click="refreshAuction()"
        ></i>
      </div>
      <div class="col">
        <i
          class="bi bi-person"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          @click="store.setViewerModalType('player')"
        ></i>
      </div>
      <div class="col">
        <i class="bi bi-x-lg text-danger" @click="clearAuction()"></i>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col bg-info rounded">{{ msg }}</div>
    </div>
    <div class="row" v-if="!msg">
      <div class="col">
        <div v-if="auction.bidding_open && auction.live_player_id">
          <PlayerInfo></PlayerInfo>
        </div>
        <div v-else>
          <AuctionIcon></AuctionIcon>
        </div>
        <div class="row" v-if="auction.bidding_open && auction.live_player_id">
          <div class="col"><BidsListner></BidsListner></div>
        </div>
        <TeamsList></TeamsList>
      </div>
    </div>
    <TeamModal></TeamModal>
    <!-- <PlayersModal></PlayersModal> -->
  </div>
</template>

<script setup>
import supabase from "@/supabase/config";
import { onMounted, ref } from "vue";
import { useStore } from "@/store/index";
import AuctionIcon from "../../bidder/liveauction/AuctionIcon.vue";
import PlayerInfo from "../player/PlayerInfo.vue";
import BidsListner from "../bids/BidsListner.vue";
import TeamsList from "../teams/TeamsList.vue";
import TeamModal from "../modal/TeamModal.vue";

const auction = ref({});
const store = useStore();
const msg = ref("");
const clearAuction = () => {
  store.clearAuction("");
  store.setUserType("");
};
onMounted(() => {
  msg.value = "Fetching auction...";
  setTimeout(() => {
    fetchAuction();
    msg.value = "";
  }, 1000);
});
const fetchAuction = async () => {
  let { data: auctions, error } = await supabase
    .from("auctions")
    .select("*")
    .eq("id", store.live_auction);
  auction.value = auctions[0];
  store.setViewerLivePlayerId(auction.value.live_player_id);
  setupAuctionListner();
};
const setupAuctionListner = () => {
  const channels = supabase
    .channel("viewer-auctions8ll-custom-update-channel")
    .on(
      "postgres_changes",
      { event: "UPDATE", schema: "public", table: "auctions" },
      (payload) => {
        //console.log("Change received!", payload);
        if (payload.new.id == store.live_auction) {
          auction.value = payload.new;
          if (auction.value.live_player_id) {
            store.setViewerLivePlayerId(auction.value.live_player_id); //done to fetch liveplayer in PlayerInfo component
          }
        }
      }
    )
    .subscribe();
};
const refreshAuction = () => {
  msg.value = "Refreshing...";
  setTimeout(() => {
    fetchAuction();
    msg.value = "";
  }, 2000);
};
</script>
